module.exports = __webpack_public_path__ + "img/logo-jurisprudencia-rodape.858230d0.png";